/**
 * Bulk add to cart web component (controller).
 * Intercepts form submit when [data-bulk-add] exist and adds bundle items.
 */
import { getCart } from "customUtils";

class BulkAddForm extends HTMLElement {
  constructor() {
    super();
    this._submitHandler = this._handleSubmit.bind(this);
  }

  connectedCallback() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const bulkAdds = Array.from(document.querySelectorAll("[data-bulk-add]") ?? []);
    if (bulkAdds.length === 0) return;

    form.addEventListener("submit", this._submitHandler, { capture: true });
  }

  disconnectedCallback() {
    const form = document.querySelector('form[action*="/cart/add"]');
    form?.removeEventListener("submit", this._submitHandler, { capture: true });
  }

  _handleSubmit(event) {
    const form = event.target;
    if (form.action && !form.action.includes("/cart/add")) return;

    event.stopImmediatePropagation();
    event.stopPropagation();
    event.preventDefault();

    this._bulkAdd(event, form);
  }

  _bulkAdd(event, form) {
    const bulkAdds = document.querySelectorAll("[data-bulk-add]");
    if (!bulkAdds.length) return;

    const currentVariantId = form.querySelector('input[name="id"]')?.value;
    if (!currentVariantId) return;

    const formData = { items: [] };
    const bundleUuid = window.crypto.randomUUID();

    formData.items.push({
      id: currentVariantId,
      quantity: 1,
      properties: { _bundle_uuid: bundleUuid },
    });

    const activeBulkAdds = [...bulkAdds].filter(
      (input) =>
        (input.type === "checkbox" && input.checked && input.dataset?.quantity) ||
        (input.type === "hidden" && input.dataset?.quantity)
    );

    activeBulkAdds.forEach((bulkAdd) => {
      formData.items.push({
        id: +bulkAdd.value,
        quantity: bulkAdd.dataset.quantity,
        parent_id: currentVariantId,
        properties: { _bundle_uuid: bundleUuid },
      });
    });

    if (formData.items.length === 0) return;

    this._addToCart(formData);
  }

  async _addToCart(formData) {
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const form = document.querySelector('form[action*="/cart/add"]');
    const currentVariantIdInput = form?.querySelector('input[name="id"]');
    const sectionIdInput = form?.querySelector('input[name="section-id"]');

    if (!currentVariantIdInput) return;

    try {
      const response = await fetch("/cart/add.js", {
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          items: formData.items,
          "section-id": sectionIdInput?.value,
          sections_url: `${window.Shopify.routes.root}variants/${currentVariantIdInput.value}`,
          sections: sectionsToBundle.join(","),
        }),
      });

      const data = await response.json();

      if (response.ok) {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartContent = await cartResponse.json();
        cartContent.sections = data.sections;
        getCart(cartContent, "variant:add");
      } else {
        console.error("Error:", data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
}

customElements.define("bulk-add-form", BulkAddForm);
